module.exports = flarum.extensions['DeepIntegrations-seo'];